/**
 * Returns a new object with the same keys as the input object, but sorted alphabetically.
 *
 * For example, `{ foo: 1, bar: 2 }` becomes `{ bar: 2, foo: 1 }`.
 *
 * @param unordered The object to sort
 * @returns The object with keys sorted alphabetically
 */
export const sortedObject = <T extends object>(unordered: T): T =>
  Object.keys(unordered)
    .sort()
    .reduce((ordered, key) => {
      const typedKey = key as keyof T // Just to make TypeScript happy
      ordered[typedKey] = unordered[typedKey]
      return ordered
    }, {} as T)
